<template>
  <div class="LineColumn">
    <div class="title" v-if="isShowTitle">
        <span>{{dataTitle}}</span>
        <span v-show="hasMore===1" class="more" @click="toMore">更多<img src="@/assets/icon_jump.png"></span>
    </div>
    <div class="list">
        <div class="item" v-for="(item, key) in list" :key="key" @click="clickOpen(item)">
            <img :src="item.icon">
            <div class="content">
                <div class="title">{{item.title}}</div>
                <div class="comment">{{item.comment|commentFilter}}</div>
                <div class="info">
                    <!-- <img v-if="item.type == 1" src="@/assets/icon_play_blue.png">
                    <img v-else src="@/assets/icon_listen_blue.png">
                    <span>{{item.playback}}次播放</span> -->
                    <span style="flex:1"></span>
                    <!-- <span class="price" v-if="item.price">¥{{item.price | money}}</span>
                    <span class="old_price" v-if="item.old_price && item.price != item.old_price">¥{{item.old_price | money}}</span> -->
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'
import { money } from '@/utils/index'
import { substring } from '@/utils/index'
export default {
  name: 'LineColumn',
  props: {
    isShowTitle: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Number,
      default: 1
    },
    dataId: {
      default: null
    },
    dataTitle: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  filters: {
    money,
    commentFilter(comment) {
      return substring(comment, 20, true)
    }
  },
  data () {
    return {
    }
  },
  methods: {
    toMore: function(item){
      this.$emit('clickMore', this.dataId, this.dataTitle);
    },
    clickOpen: function(item){
      cblockItem(item, this)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.LineColumn{
    padding: 8px 16px;
    color: #333;
}
.LineColumn > .title{
    display: flex;
    justify-content:space-between;
    font-size: 18px;
    font-weight: 600;
    padding: 13px 0;
}
.LineColumn .title .more{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 100;
    color: #AAA;
}
.LineColumn .title img{
    width: 16px;
}
.LineColumn .list .item{
    padding-bottom: 6px;
    border-radius: 6px;
    margin-bottom: 10px;
    display: flex;
    box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.06);
}
.LineColumn .list .item > img{
    width: 93px;
    height: 93px;
    display: inherit;
    border-radius: 6px;
}
.LineColumn .list .item .content{
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 0 0 13px;
    text-align: left;
}
.LineColumn .list .item .content .title{
    font-size: 16px;
    font-weight: 600;
}
.LineColumn .list .item .content .comment{
    flex: 1;
    font-size: 13px;
    color: #999999;
    margin-bottom: 5px;
    padding: 6px 0;
}
.LineColumn .list .item .content .info{
    display: flex;
    align-items: center;
    color: #999999;
}
.LineColumn .list .item .content .info img{
    width: 19px;
    height: 19px;
    margin-right: 6px;
}
.LineColumn .list .item .content .info .price{
    font-size: 13px;
    color: #FF8549;
}
.LineColumn .list .item .content .info .old_price{
    font-size: 10px;
    text-decoration:line-through;
    margin-left: 6px;
}
</style>
